import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _debounce from 'lodash/debounce';
import _noop from 'lodash/noop';
import _filter from 'lodash/filter';
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { VIEW_TYPE_TO_NOTE_ITEM_COMPONENT } from './noteItem.constants';
import NoteReader from '../Note.reader';
import { getEditAction, getDeleteAction, getPinAction } from '../constants/note.general';
import { getNoteItemData, shouldShowDeleteOptionForNote } from './noteItem.helpers';
import './noteItem.scss';
var NoteItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NoteItem, _React$PureComponent);
  var _super = _createSuper(NoteItem);
  function NoteItem(props) {
    var _this;
    _classCallCheck(this, NoteItem);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handlePinAction", function () {
      var _this$props = _this.props,
        assetId = _this$props.assetId,
        noteItem = _this$props.noteItem,
        handlePinAction = _this$props.handlePinAction;
      handlePinAction(assetId, NoteReader.getNoteId(noteItem), NoteReader.isNotePinned(noteItem));
    });
    _defineProperty(_assertThisInitialized(_this), "handleNoteDelete", function () {
      var _this$props2 = _this.props,
        assetId = _this$props2.assetId,
        noteItem = _this$props2.noteItem,
        handleDeleteNote = _this$props2.handleDeleteNote;
      handleDeleteNote(assetId, NoteReader.getNoteId(noteItem));
    });
    _defineProperty(_assertThisInitialized(_this), "toggleNoteUpdate", function () {
      _this.setState(function (prevState) {
        return {
          editing: !prevState.editing
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleAddOrUpdate", function (updatedNote, taggedUsers) {
      var _this$props3 = _this.props,
        assetId = _this$props3.assetId,
        noteItem = _this$props3.noteItem,
        handleUpdateNote = _this$props3.handleUpdateNote;
      handleUpdateNote(assetId, NoteReader.getNoteId(noteItem), updatedNote, taggedUsers);
      _this.toggleNoteUpdate();
    });
    _defineProperty(_assertThisInitialized(_this), "getActions", function (showActionButtons) {
      var _this$props4 = _this.props,
        showPinnedNote = _this$props4.showPinnedNote,
        noteItem = _this$props4.noteItem,
        canDeleteAnyNote = _this$props4.canDeleteAnyNote,
        canDeleteSelfAddedNote = _this$props4.canDeleteSelfAddedNote,
        currentUser = _this$props4.currentUser;
      var isSameUser = NoteReader.getUserId(noteItem) === NoteReader.getNoteId(currentUser);
      var showDeleteOptionInMenu = shouldShowDeleteOptionForNote({
        showActionButtons: showActionButtons,
        canDeleteAnyNote: canDeleteAnyNote,
        canDeleteSelfAddedNote: canDeleteSelfAddedNote,
        isSameUser: isSameUser
      });
      return [getPinAction(_this.handlePinAction, showPinnedNote, NoteReader.isNotePinned, noteItem), getEditAction(_this.toggleNoteUpdate, showActionButtons), getDeleteAction(_this.handleNoteDelete, showDeleteOptionInMenu)];
    });
    _defineProperty(_assertThisInitialized(_this), "getNoteActions", function () {
      var editing = _this.state.editing;
      var _this$props5 = _this.props,
        disableActionButtons = _this$props5.disableActionButtons,
        singleComment = _this$props5.singleComment,
        currentUser = _this$props5.currentUser,
        noteItem = _this$props5.noteItem;
      var isNoteEditable = NoteReader.isNoteEditable(currentUser, noteItem);
      var showActionButtons = !disableActionButtons && (!editing && isNoteEditable || singleComment);
      return _filter(_this.getActions(showActionButtons), {
        isVisible: true
      });
    });
    _this.handleNoteDelete = _debounce(_this.handleNoteDelete, 300);
    _this.state = {
      editing: false
    }; // specifies whether or not the note is in editing state
    return _this;
  }
  _createClass(NoteItem, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        noteItem = _this$props6.noteItem,
        view = _this$props6.view,
        validators = _this$props6.validators,
        hideActions = _this$props6.hideActions,
        enableMentions = _this$props6.enableMentions,
        personas = _this$props6.personas,
        className = _this$props6.className;
      var editing = this.state.editing;
      var noteActions = this.getNoteActions();
      var isNoteUnread = NoteReader.isNoteUnRead(noteItem);
      var noteItemClassName = cx(className, 'note-item', {
        highlight: isNoteUnread
      });
      var _getNoteItemData = getNoteItemData(noteItem),
        userImage = _getNoteItemData.userImage,
        userName = _getNoteItemData.userName,
        userRole = _getNoteItemData.userRole,
        noteDate = _getNoteItemData.noteDate,
        isNoteEdited = _getNoteItemData.isNoteEdited,
        noteText = _getNoteItemData.noteText,
        associatedUsers = _getNoteItemData.associatedUsers;
      var tags = NoteReader.tags(noteItem) || EMPTY_ARRAY;
      var NoteItemComponent = VIEW_TYPE_TO_NOTE_ITEM_COMPONENT[view];
      return /*#__PURE__*/React.createElement(NoteItemComponent, {
        userImage: userImage,
        userName: userName,
        userRole: userRole,
        noteDate: noteDate,
        isNoteEdited: isNoteEdited,
        noteText: noteText,
        editing: editing,
        hideActions: hideActions,
        noteActions: noteActions,
        handleAddOrUpdate: this.handleAddOrUpdate,
        validators: validators,
        className: noteItemClassName,
        tags: tags,
        associatedUsers: associatedUsers,
        enableMentions: enableMentions,
        personas: personas
      });
    }
  }]);
  return NoteItem;
}(React.PureComponent);
_defineProperty(NoteItem, "propTypes", {
  assetId: PropTypes.string,
  noteItem: PropTypes.object,
  currentUser: PropTypes.object,
  handleUpdateNote: PropTypes.func.isRequired,
  handleDeleteNote: PropTypes.func.isRequired,
  view: PropTypes.string.isRequired,
  disableActionButtons: PropTypes.bool.isRequired,
  handlePinAction: PropTypes.func,
  showPinnedNote: PropTypes.bool,
  hideActions: PropTypes.bool,
  canDeleteAnyNote: PropTypes.bool,
  canDeleteSelfAddedNote: PropTypes.bool,
  validators: PropTypes.array,
  singleComment: PropTypes.bool,
  enableMentions: PropTypes.bool,
  personas: PropTypes.array
});
_defineProperty(NoteItem, "defaultProps", {
  assetId: EMPTY_STRING,
  noteItem: EMPTY_OBJECT,
  currentUser: EMPTY_OBJECT,
  handlePinAction: _noop,
  showPinnedNote: false,
  hideActions: false,
  canDeleteAnyNote: false,
  canDeleteSelfAddedNote: true,
  validators: EMPTY_ARRAY,
  singleComment: false,
  enableMentions: false,
  personas: EMPTY_ARRAY
});
export default NoteItem;